import type { SxProps, Theme } from "@mui/material/styles";

export const paper: SxProps<Theme> = {
  borderRadius: 3,
  maxWidth: 560,
};

export const content: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  maxHeight: 420,
  overflowY: "auto",
});

export const sectionTitle: SxProps<Theme> = (theme) => ({
  fontWeight: 700,
  fontSize: theme.typography.body1.fontSize,
});

export const sectionBody: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.8,
});

export const actions: SxProps<Theme> = (theme) => ({
  px: theme.spacing(3),
  pb: theme.spacing(2),
  gap: theme.spacing(1),
});
